import {createReducer} from "@reduxjs/toolkit";
import {productSearchToggleFiltersAction} from "../action/ProductSearchToggleFiltersAction";
import {ProductSearchState} from "../entity/ProductSearchState";
import {updateLastSearchFilterAction} from "../action/UpdateLastSearchFilterAction";
import {updateLastSearchResultAction} from "../action/UpdateLastSearchResultAction";
import {userLogoutAction} from "../action/UserLogoutAction";

const initialValue = {
    filterSearch: '',
    isFiltersExpanded: true,
    filterProductProperties: {},
    count: undefined,
    products: undefined
} as ProductSearchState

export const productSearchStateReducer = createReducer(initialValue, (builder) => {
    builder.addCase(productSearchToggleFiltersAction, (state, action) => ({
        ...state,
        isFiltersExpanded: !state.isFiltersExpanded
    }))
    builder.addCase(updateLastSearchFilterAction, (state, action) => ({
        ...state,
        filterReleaseType: action.payload.filterReleaseType,
        filterSearch: action.payload.filterSearch,
        filterProductProperties: action.payload.filterValues,
    }))
    builder.addCase(updateLastSearchResultAction, (state, action) => ({
        ...state,
        products: action.payload.products,
        count: action.payload.count,
    }))
    builder.addCase(userLogoutAction, (state, action) => ({
        ...initialValue
    }))
})